import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OptionsSelectModel } from '../../models/option';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements OnInit {

  @Input() id!: string;
  @Input() formGroup!: FormGroup | any;
  @Input() label: string = '';
  @Input() options!: OptionsSelectModel[];
  @Input() hasOptionDisabled: boolean = false;
  @Input() hideSelected: boolean = false;
  @Input() multiple: boolean = false;
  @Input() clearable: boolean = false;
  @Input() addTag: boolean = false;
  @Input() searchable: boolean = true;
  @Input() addTagText: string = "Adicionar novo";
  @Input() showError: boolean = true;

  @Output() onValueChange = new EventEmitter<string>();


  optionsList:  OptionsSelectModel[] = [];

  constructor() { }

  ngOnInit(): void {
    this.optionsList = this.options;
    if (this.formGroup.get(this.id)?.value) {
      let list = this.formGroup.get(this.id)?.value;
      if (typeof (list) == "object") {
        let item = list.map((item: any) => item.toString());
        this.formGroup.get(this.id).setValue(item);
      } else {
        let item = this.formGroup.get(this.id).value;
        this.formGroup.get(this.id).setValue(item.toString());
      }
    }
  }

  clickHandle(e: any) {
    this.optionsList = this.options;
    if (this.formGroup.get(this.id)?.valid) {
      this.onValueChange.emit(this.formGroup.get(this.id)?.value);
    }
  }

  addNewTag(e: any) {
    return {
      value: e,
      label: e
    };
  }

}
